const Payment = () => {
  return null;
};

export default Payment;
